<dxp-link-selector *ngIf="this.exportType.length > 1" selector-id="export" data-source-key-name="value" [items]="this.exportType"
    search-placeholder="Export" placeholder="Export" optional=true
    (selectedItemChanged)="setSelectedExport($event)" list-aria-label="Export link to export the Grid data" #exportDropDown>
</dxp-link-selector>
<dxp-link *ngIf="this.exportType.length == 1 && this.exportType[0].value=='Export'" link-id="exportLink" state="enabled" open-in-new-tab="false" type="dxp-btn-custom-link" [text]="this.exportType[0].value"
    aria-label="Export link to export the Grid data" (click)="exportToExcel()" >
</dxp-link>
<dxp-modal content-id="modal-1" cancel-button=false button-position="right" demo="false" demo-button-text='Show Modal'
    footer-type="no-button" close-on-outside-click="false"  #modalReference>
    <div class="dxp-row dxp-bg-initial">
        <div class="dxp-bg-initial dxp-col-md-12">
            <dxp-flex-layout>
                <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12"
                    padding-style-sm="0px 15px">
                    <dxp-message severity="warn" close-button=true close-button-title="Close button!"
                        *ngIf="radioSelectionErrorStatus">
                        <dxp-message-text text="{{msg.export.exportSelectRadioOption}}"></dxp-message-text>
                    </dxp-message>
                    <p class="feature-title">{{msg.export.exportBBLogTitle}}</p>
                    <p>{{msg.export.exportBBLogDescription}}</p>
                    <dxp-radio-group input-id="blue_balloon_log" alignment="verticle"
                        (radioSelected)="getSelectedBBRadio($event)" #exportRadioGroup>
                        <dxp-radio-button label="Pins from data grid" radio-key="pins_from_data_grid" value="data_grid" #pinsFromDataGridReference></dxp-radio-button>
                        <dxp-radio-button label="Pins from list" radio-key="pins_from_list" value="from_list">
                        </dxp-radio-button>
                    </dxp-radio-group>
                </dxp-flex-layout-item>
                <dxp-flex-layout-item slot="column-2" column-width-sm="12" column-width-lg="12"
                    padding-style-sm="0px 15px">
                    <dxp-textarea value="" optional="true" placeholder="{{msg.export.exportBBTextareaPlaceholder}}"
                        rows="5" cols="40" width="600" accessibility-text="Insert Address" *ngIf="pinsTextArea"
                        #pinsTextAreaReference></dxp-textarea>
                    <span class="form-validation-error"
                        *ngIf="pinsTextAreaStatus == 'invalid'">{{msg.FormValidationMessage.bbPinsRequired}}</span>
                    <span class="form-validation-error"
                        *ngIf="pinsTextAreaStatus == 'maxlimit'">{{msg.FormValidationMessage.exportBBMaxLimit}}</span>
                    <span class="form-validation-error"
                        *ngIf="pinsTextAreaStatus == 'invalidPin'">{{msg.FormValidationMessage.exportBBValidPin}}</span>
                    <p>
                        <dxp-link state="enabled" open-in-new-tab="false" type="dxp-btn-custom-link" text="Clear PINS"
                            aria-label="Clear PINS" (click)="clearPins()" *ngIf="pinsTextArea">
                        </dxp-link>
                    </p>
                </dxp-flex-layout-item>
            </dxp-flex-layout>
            <div class="dxp-mt-6 dxp-mx-2">
                <dxp-flex-layout>
                    <dxp-flex-layout-item slot="column-1" column-width-sm="3" column-width-lg="2">
                        <dxp-button type="primary" button-id="btnExport" text="Export" state="enabled"
                            aria-label="Export" button-title="Export" (click)="exportBlueBalloon()"></dxp-button>
                    </dxp-flex-layout-item>
                    <dxp-flex-layout-item slot="column-2" column-width-sm="3" column-width-lg="2">
                        <dxp-button type="secondary" button-id="btnCancel" text="Cancel" state="enabled"
                            button-title="Cancel" (click)="closeExportModal()"></dxp-button>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
            </div>
        </div>
    </div>
</dxp-modal>

<app-toaster></app-toaster>
